/*
 * ---------------------------------------------------------------------------
 * COMMERCIAL IN CONFIDENCE
 *
 * (c) Copyright Quosient Ltd. All Rights Reserved.
 *
 * See LICENSE.txt in the repository root.
 * ---------------------------------------------------------------------------
 */
const WORKFLOW_2_1 = {
    "type": "FeatureCollection",
    "features": [
        {
            "type": "Feature",
            "properties": { areaName: "Area 1", },
            "geometry": {
                "type": "Polygon",
                "coordinates": [
                    [
                        [58.001726985197436, -9.810026164649187],
                        [26.88844573519744, -9.810026164649187],
                        [26.88844573519744, -26.993804163022034],
                        [58.001726985197436, -26.993804163022034],
                        [58.001726985197436, -9.810026164649187]
                    ]
                ]
            },
        }
    ]
};

export default WORKFLOW_2_1